import { InspectionBase } from '@/components/forms/inspection/InspectionBase'

export class ContentBase extends InspectionBase {
  cost = false
  validation = false
  fieldsKeys = []
  formData = {}
  errorIdentifierMessage = {}
}
